(function () {
  "use strict";

  function bindSticky(root) {
    var sticky =
      document.querySelector("[data-ecomato-sticky]") ||
      root.querySelector("[data-ecomato-sticky]");
    if (!sticky) return;

    var tokenSource =
      document.querySelector('[data-ecomato-section="custom-product-focus"]') ||
      document.querySelector(".ecomato-section--pdp") ||
      document.body;

    [
      "--ecomato-primary",
      "--ecomato-accent",
      "--ecomato-sale",
      "--ecomato-font-family",
      "--ecomato-heading-font",
      "--ecomato-text",
      "--ecomato-muted",
      "--ecomato-border",
      "--ecomato-surface",
      "--ecomato-radius",
    ].forEach(function (prop) {
      var value = getComputedStyle(tokenSource).getPropertyValue(prop).trim();
      if (value) sticky.style.setProperty(prop, value);
    });

    // Ensure CTA fill always resolves to a real color (never Dawn RGB channels).
    if (!getComputedStyle(sticky).getPropertyValue("--ecomato-accent").trim()) {
      sticky.style.setProperty(
        "--ecomato-accent",
        getComputedStyle(sticky).getPropertyValue("--ecomato-primary").trim() ||
          "#0F766E",
      );
    }
    if (!getComputedStyle(sticky).getPropertyValue("--ecomato-surface").trim()) {
      sticky.style.setProperty("--ecomato-surface", "#ffffff");
    }

    if (sticky.parentElement !== document.body) {
      document.body.appendChild(sticky);
    }

    var onScroll = function () {
      var buybox = document.querySelector(
        ".cp-info, .cp-buy-btn, .ecomato-section--pdp",
      );
      if (!buybox) {
        sticky.setAttribute("data-visible", window.scrollY > 420 ? "true" : "false");
        return;
      }
      sticky.setAttribute(
        "data-visible",
        buybox.getBoundingClientRect().bottom < 80 ? "true" : "false",
      );
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    // Horizon scrolls `.page-wrapper` (html/body are overflow:hidden on desktop),
    // so window scroll alone never fires on the live storefront.
    var pageWrapper = document.querySelector(".page-wrapper");
    if (pageWrapper) {
      pageWrapper.addEventListener("scroll", onScroll, { passive: true });
    }
  }

  function bindCustomerTransformationTestimonials() {
    document.querySelectorAll("[data-ecomato-ctt]").forEach(function (section) {
      var track = section.querySelector("[data-ecomato-ctt-track]");
      var dotsWrap = section.querySelector(".ecomato-ctt__dots");
      var dots = section.querySelectorAll(".ecomato-ctt__dot");
      var prev = section.querySelector(".ecomato-ctt__nav--prev");
      var next = section.querySelector(".ecomato-ctt__nav--next");
      if (!track) return;

      var slides = track.querySelectorAll(".ecomato-ctt__slide");
      var count = slides.length;
      var active = 0;
      var looping = false;
      if (!count) return;

      var visibleObserver = new IntersectionObserver(
        function (entries) {
          if (
            entries.some(function (entry) {
              return entry.isIntersecting;
            })
          ) {
            section.setAttribute("data-visible", "true");
            visibleObserver.disconnect();
          }
        },
        { threshold: 0.2 },
      );
      visibleObserver.observe(section);

      function hasOverflow() {
        return track.scrollWidth > track.clientWidth + 4;
      }

      function setNavVisible(visible) {
        var display = visible ? "" : "none";
        if (prev) prev.style.display = display;
        if (next) next.style.display = display;
        if (dotsWrap) dotsWrap.style.display = display;
        section.setAttribute("data-ctt-overflow", visible ? "true" : "false");
      }

      function syncOverflow() {
        setNavVisible(hasOverflow());
      }

      function stepSize() {
        var slide = slides[0];
        if (!slide) return 0;
        var gap = parseFloat(window.getComputedStyle(track).gap || "0");
        return slide.offsetWidth + gap;
      }

      function setActive(index) {
        active = ((index % count) + count) % count;
        dots.forEach(function (dot, dotIndex) {
          dot.setAttribute("data-active", dotIndex === active ? "true" : "false");
        });
      }

      function goTo(index) {
        if (!hasOverflow()) return;
        var step = stepSize();
        if (!step) return;
        looping = true;
        track.scrollTo({ left: index * step, behavior: "smooth" });
        setActive(index);
        window.setTimeout(function () {
          looping = false;
        }, 450);
      }

      function sync() {
        if (looping) return;
        var step = stepSize();
        if (!step) return;
        setActive(Math.round(track.scrollLeft / step));
      }

      track.addEventListener("scroll", sync, { passive: true });
      if (prev) {
        prev.addEventListener("click", function () {
          if (!hasOverflow()) return;
          goTo(active - 1 < 0 ? count - 1 : active - 1);
        });
      }
      if (next) {
        next.addEventListener("click", function () {
          if (!hasOverflow()) return;
          goTo(active + 1 >= count ? 0 : active + 1);
        });
      }
      dots.forEach(function (dot) {
        dot.addEventListener("click", function () {
          if (!hasOverflow()) return;
          goTo(Number(dot.getAttribute("data-index") || "0"));
        });
      });
      setActive(0);
      syncOverflow();
      window.addEventListener("resize", syncOverflow);
    });
  }

  function boot() {
    bindSticky(document);
    bindCustomerTransformationTestimonials();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (event.target) bindSticky(event.target);
  });
})();
